import { formatTimeAgo } from '@vueuse/core';

export const unixTimestampToDate = (value) => {
    if (value instanceof Date) {
        return value;
    }

    if (value && typeof value.toDate === 'function') {
        return value.toDate();
    }

    if (typeof value === 'number') {
        const timestamp = isUnixTimestamp(value) ? value * 1000 : value;
        return new Date(timestamp);
    }

    if (typeof value === 'string') {
        const trimmedValue = value.trim();

        if (/^\d+$/.test(trimmedValue)) {
            const numericValue = Number(trimmedValue);
            const timestamp = isUnixTimestamp(numericValue) ? numericValue * 1000 : numericValue;
            return new Date(timestamp);
        }

        return new Date(trimmedValue);
    }

    return new Date(value);
}

export const isUnixTimestamp = (timestamp) => {
    return Number.isFinite(timestamp) && Math.abs(timestamp) < 1e12;
}

export const dateTimeAgo = (date) => {
    return formatTimeAgo(unixTimestampToDate(date))
}

